import React, { useEffect, useState, useMemo } from 'react'
import callApi from 'services/api'
import {
  faArrowLeft,
  faEdit,
  faMagnifyingGlass,
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { formatDate } from 'utils/DateFormatter'
import { loadingState } from 'global/LoaderState'
import { useRecoilState, useSetRecoilState } from 'recoil'
import { AlertState } from 'global/AlertState'
import AddDelinquency from './AddDelinquency'
import debounce from 'lodash.debounce'
import { UserState } from 'global/UserState'
import { useLocation } from 'react-router-dom'
import FirTable from './FirTable'
import { Accordion } from 'react-bootstrap'
import { BsCaretRightFill } from 'react-icons/bs'
import { TiThList } from 'react-icons/ti'
import DeTable from './DETable'
import AcrTable from './ACRTable'
import { AiOutlineSafetyCertificate } from 'react-icons/ai'
import { getMasterdata, getList } from './apis'

const ViewDelinquency = () => {
  const [showModal, setShowModal] = useState(false)
  const { state } = useLocation()
   const location = useLocation();
  const item = location.state?.item;

  const [user] = useRecoilState(UserState)

  const loader = useSetRecoilState(loadingState)
  const [loading, setLoading] = useState(false)
  const [selectedEmpId, setSelectedEmpId] = useState(null)

  const [editingData, setEditingData] = useState()
  const [error, setError] = useState(null)
  const [empList, setEmpList] = useState([])
  const [deliquencyList, setDeliquencyList] = useState([])
  const [search, setSearch] = useState('')

  const getDeliquency = async (search) => {
    try {
      loader(true)
      setLoading(true)
      setError(null)
      console.log("deli",item)
      const params = new URLSearchParams({
        search: search,
        search_field: 'empId',
        page: '-1',
        limit: '10',
        ...(item && { employeeId: item }),
      })
      //  const params = new URLSearchParams({
      //   search: search || "",
      //   search_field: "name",
      //   page: page.toString(),
      //   limit: limit.toString(),
      //   ...(item && { employeeId: item }), // Only add employeeId if item exists
      // });
      const response = await callApi(
        `deliquency/list?${params}`,
        'GET',
        null,
        true,
        true,
        (msg) => setError(msg),
        (path) => console.log('navigate to', path)
      )

      if (response.success) {
        const payload = response?.body?.data || []


        setDeliquencyList(payload)
      }
    } catch (err) {
      setError(err.message || 'Failed to load employees')
    } finally {
      loader(false)
      setLoading(false)
    }
  }

  const handleOpenModal = (data = null) => {
    setEditingData(data)
    setShowModal(true)
  }

  const handleCloseModal = () => {
    setEditingData(null)
    setShowModal(false)
  }

  useEffect(() => {
    const { data } = state || {}


    const fetchEmployee = async () => {
      const rankData = data?.rank ? await getMasterdata(data.rank) : null

      const enrichedEmployee = {
        ...data,
        dob: formatDate(data?.dob),
        rankName: rankData?.name,
      }

      setEmpList([enrichedEmployee]) // keep as array for table/list rendering
    }


    if (data) {
      fetchEmployee()
      setSelectedEmpId(data?.id)
      getDeliquency(data?.id)
    }
  }, [state])

  const renderRows = () => {
    if (!empList || empList.length === 0) {
      return (
        <tr>
          <td colSpan={7} className="p-3 text-start">
            No Delinquency
          </td>
        </tr>
      )
    }

    return empList.map((item) => (
      <tr key={item.id}>
        <th className="text-center">{item.empCode}</th>
        <th className="text-center">{item.name}</th>
        <th className="text-center">{item.dob}</th>
        <th className="text-center">{item.rankName}</th>
        <th className="text-center">{item.beltNumber}</th>
        <th className="text-center">{item.postingName}</th>
        <th className="text-center">
          <button
            type="button"
            onClick={() => handleOpenModal(item)}
            className="btn btn-outline-warning btn-sm px-3 py-2 shadow-sm"
            style={{ textDecoration: 'none' }}
          >
            <FontAwesomeIcon icon={faEdit} className="me-1" />
            Add Delinquency
          </button>
        </th>
      </tr>
    ))
  }

  return (
    <div className="container">
      <div className="ms-3 me-3 mt-3 d-flex justify-content-between bg-dark rounded ">
        <h5 className="card-title  p-3 m-0 text-white">Delinquency</h5>
        <h6 className="card-title p-3 mt-1 text-white text-sm">
          Department : {user.unit || ''}
          {user.subUnit ? ` | ${user.subUnit}` : ''}
        </h6>
      </div>
      <div className="card-body ms-3">
        <>
          <div className="table-responsive mt-4">
            <table className="table table-striped">
              <thead>
                <tr>
                  <th className="text-center ">Unique ID</th>
                  <th className="text-center">Name</th>
                  <th className="text-center">Date Of Birth</th>
                  <th className="text-center">Rank</th>
                  <th className="text-center">Belt Number</th>
                  <th className="text-center">Posting</th>
                  <th className="text-center">Action</th>
                </tr>
              </thead>
              <tbody>{renderRows()}</tbody>
            </table>
          </div>

          {deliquencyList.length == 0 && (
            <div>
              <h5>
                <span className="me-3">
                  <AiOutlineSafetyCertificate />
                </span>
                No Deliquency
              </h5>
            </div>
          )}

          {deliquencyList.length > 0 && (
            <div>
              <h5>
                <span className="me-3">
                  <TiThList />
                </span>
                List of Deliquencies:
              </h5>
              <span className="text-muted text-sm">
                No. of Deliquencies : {deliquencyList.length}
              </span>
            </div>
          )}

          <Accordion alwaysOpen>

            {deliquencyList.map((item, idx) => (
              <Accordion.Item eventKey={String(idx)} key={item.id || idx}>
                <Accordion.Header>
                  {idx+1}
                  <BsCaretRightFill />
                  {item.typeOfdeliquency === 'fir' && (
                    <div className="d-flex align-items-center">
                      <span className="ms-2">
                        FIR Number: {item.data.firNumber}
                      </span>
                    </div>
                  )}
                  {item.typeOfdeliquency === 'de' && (
                    <div className="d-flex align-items-center">
                      {/* <BsCaretRightFill /> */}
                      <span className="ms-2">Departmental Action</span>
                    </div>
                  )}
                  {item.typeOfdeliquency === 'acr' && (
                    <div className="d-flex align-items-center">
                      {/* <BsCaretRightFill />  */}
                      <span className="ms-2">Annual Confidential Report</span>
                    </div>
                  )}
                </Accordion.Header>
                <Accordion.Body>
                  {item.typeOfdeliquency === 'fir' && (
                    <FirTable payload={item} onSuccess={() => getDeliquency(item?.empId)} />
                  )}

                  {item.typeOfdeliquency === 'de' && (
                    <DeTable payload={item} onSuccess={() => getDeliquency(item?.empId)} />
                  )}
                  {item.typeOfdeliquency === 'acr' && (
                    <AcrTable payload={item} onSuccess={() => getDeliquency(item?.empId)} />
                  )}
                </Accordion.Body>
              </Accordion.Item>
            ))}
          </Accordion>
          <AddDelinquency
            showModal={showModal}
            empId={editingData}
            onSuccess={() => getDeliquency(selectedEmpId)}
            handleCloseModal={handleCloseModal}
          />
        </>
      </div>
    </div>
  )
}

export default ViewDelinquency
